import 'parent-node-prepend-polyfill'
import 'polyfill-nodelist-foreach'
import 'promise/polyfill'
import 'whatwg-fetch'
import 'element-closest-polyfill'
import * as helper from './component/product/helper'
import { windowLoaded } from './utilities/domready'
import { Mobile } from './component/product/mobile'
import { Article } from './component/product/article'
import { Gallery } from './component/product/gallery'
import { Buybox } from './component/product/buybox'
import { Toggle } from './component/product/toggle'
import { Variants } from './component/product/variants'
import { Accessory } from './component/product/accessory'
import { OrderedTogether } from './component/product/orderedTogether'
import { Reco } from './component/product/reco'
import { Rating } from './component/product/rating'
import { toCart } from './component/product/tocart'
import { Reminder } from './component/product/reminder'
import { StickyPDA } from './component/product/sticky'

declare global {
    interface Window {
        articleFeatureMap: any;
        fullFeatureArticleMap: any;
    }
}

let pdaArticle = new Article();
let pdaGallery = new Gallery();
let pdaBuybox = new Buybox();
let pdaToggle = new Toggle();
let pdaVariants = new Variants();
let pdaAccessory = new Accessory();
let pdaOrderedTogether = new OrderedTogether();
let pdaToCart = new toCart();
let pdaReminder = new Reminder();
let pdaRating = new Rating();
let reco = new Reco();
let sticky = new StickyPDA();
let mobile = new Mobile();

mobile.init();
pdaArticle.init();
pdaGallery.init();
pdaBuybox.init();
pdaToggle.init();
pdaVariants.init();
pdaAccessory.init();
pdaOrderedTogether.init();
pdaToCart.init();
pdaReminder.init();
pdaRating.init();
reco.init();
sticky.init();

windowLoaded(() => {
    helper.updatePriceListName();
});